import React, { Fragment } from 'react';

// components
import StarRatings from '@zola/zola-ui/src/components/StarRatings/StarRatings';
import P from '@zola/zola-ui/src/typography/Paragraphs';
import T from '@zola/zola-ui/src/typography/Text';
import { testimonials } from './testimonialContent';

// styles
import {
  Container,
  StyledHTitle3,
  Divider,
  Name,
  Testimonial,
  TestimonialContainer,
  TestimonialTitle,
} from './Testimonials.styles';

const Testimonials = (): JSX.Element => {
  return (
    <Container>
      <StyledHTitle3 presentation="h2">
        Loved by over <T.Serif>2 million couples</T.Serif>
      </StyledHTitle3>
      <TestimonialContainer>
        {testimonials.map((testimonial, index) => (
          <Fragment key={`testimonial-${index}`}>
            {index > 0 ? <Divider /> : null}
            <Testimonial>
              <Name>{testimonial.name}</Name>
              <StarRatings activeStars={5} fillColor="#FDBF00" totalStars={5} reviewCount="" />
              <TestimonialTitle>{testimonial.title}</TestimonialTitle>
              <P.BodyBase>{testimonial.body}</P.BodyBase>
            </Testimonial>
          </Fragment>
        ))}
      </TestimonialContainer>
    </Container>
  );
};

export default Testimonials;
